import { createEvent } from 'effector';
import {
  $cdekChosenDots,
  $expressChosenDots,
  $janaPostChosenDots,
  $kimigoChosenDots,
  $ozonChosenDots,
  $wildberriesChosenDots,
} from './stores.js';

export const changeTableChosenEv = createEvent();

export const changeTableOurChosenEv = createEvent();

export const changeCheckedPlacesEv = createEvent();

export const updateTableAndChartEv = createEvent();

export const selectAllPlacesEv = createEvent();

export const clearPlacesEv = createEvent();

export const invertPlacesEv = createEvent();

export const changeLayerTableEv = createEvent();

export const changeActiveLayersEv = createEvent();

export const changeExpressChosenDotsEv = createEvent();
export const changeCdekChosenDotsEv = createEvent();
export const changeJanaPostChosenDotsEv = createEvent();
export const changeKimigoChosenDotsEv = createEvent();
export const changeOzonChosenDotsEv = createEvent();
export const changeWildberriesChosenDotsEv = createEvent();

export const resetByGradientEv = createEvent();

export const setByPLaceEv = createEvent();
export const setWithGradientEv = createEvent();

export const toggleShowPopulationHexEv = createEvent();

export const clearBySearchEv = createEvent();

export const toggleMeasureModeEv = createEvent()
export const changeCurrentMeasureEv = createEvent()

export const toggleIsRoutingEv = createEvent()
export const changeRoutingTypeEv = createEvent()
export const setRoutingPointTypeEv = createEvent()
export const resetRoutingPointTypeEv = createEvent()
export const changeRoutingPointsEv = createEvent()
